if (!customElements.get('sticky-variant-select')) {
  customElements.define('sticky-variant-select', class extends HTMLElement {});
}

const stickyScroll = () => {
  document.querySelectorAll('.product__sticky').forEach(wrapper => {
    if (wrapper.dataset.lumeruneStickyReady === 'true') return;
    const section = wrapper.dataset.section;
    const mainForm = document.getElementById(`product-form-${section}`);
    const stickyForm = document.getElementById(`product-sticky-form-${section}`);
    const primary = mainForm?.closest('.product_buy_button_form');
    const mainButton = mainForm?.querySelector('button[name="add"]');
    const stickyButton = stickyForm?.querySelector('button[name="add"]');
    const mainInput = mainForm?.querySelector('input[name="id"]');
    const stickyInput = stickyForm?.querySelector('input[name="id"]');
    const select = wrapper.querySelector('sticky-variant-select select');
    const picker = Array.from(document.querySelectorAll('variant-selects, variant-radios'))
      .find(element => element.dataset.section === section);
    if (!primary || !mainButton || !stickyButton || !mainInput || !stickyInput) return;
    wrapper.dataset.lumeruneStickyReady = 'true';

    const getVariant = () => {
      if (!picker) return null;
      const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
      const options = fieldsets.length
        ? fieldsets.map(fieldset => fieldset.querySelector('input:checked')?.value)
        : Array.from(picker.querySelectorAll('select'), option => option.value);
      return picker.getVariantData().find(variant =>
        variant.options.every((option, index) => option === options[index]));
    };
    const sync = () => {
      const variant = getVariant();
      const id = picker ? String(variant?.id || '') : mainInput.value;
      stickyInput.value = id;
      if (select) select.value = id;
      const blocked = !id || (picker && !variant?.available) || mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true' || mainButton.classList.contains('loading');
      stickyButton.disabled = Boolean(blocked);
      stickyButton.textContent = mainButton.textContent;
      stickyButton.classList.toggle('loading', mainButton.classList.contains('loading'));
    };

    select?.addEventListener('change', () => {
      const variant = picker?.getVariantData().find(item => String(item.id) === select.value);
      if (!variant || !variant.available) {
        sync();
        return;
      }
      const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
      if (fieldsets.length) {
        fieldsets.forEach((fieldset, index) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = input.value === variant.options[index];
          });
        });
      } else {
        picker.querySelectorAll('select').forEach((option, index) => {
          option.value = variant.options[index];
        });
      }
      picker.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });
    mainInput.addEventListener('change', sync);
    picker?.addEventListener('change', sync);
    new MutationObserver(sync).observe(mainButton, {
      attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'],
      childList: true, subtree: true, characterData: true
    });
    sync();
    stickyForm.addEventListener('submit', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      sync();
      if (!stickyButton.disabled && mainInput.value === stickyInput.value) mainButton.click();
    }, true);

    const setVisible = visible => {
      wrapper.classList.toggle('sticky', visible);
      document.body.classList.toggle('sticky__cart', Boolean(document.querySelector('.product__sticky.sticky')));
    };
    // A fast swipe can skip the button without changing its intersection state.
    // Coalesce scroll updates so that this still needs at most one read per frame.
    let frame = null;
    const schedule = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        setVisible(primary.getBoundingClientRect().bottom <= 0);
      });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(schedule).observe(primary);
    }
    schedule();
  });
};
stickyScroll();
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', stickyScroll);
}
